/* eslint-disable @typescript-eslint/no-namespace */
import api from '@/utils/api';

declare global {
  export namespace EvalutionAnswer {
    type AnswerCardItem = {
      id: string;
      exam_id: string;
      subject_id: string;
      type: string;
      is_show: number;
      ranking: number;
      create_time: string;
      update_time: string;
      isAnswered: number;
      isMarked: number;
      subject: SubjectType.Subject2;
      answer?: any;
    };
  }
}

/**
 * 测评答题卡
 * @param params
 * @returns
 */
export async function getEvalutionAnswerCard(params: { exam_id?: string; page?: number }) {
  return api<API.Response<EvalutionAnswer.AnswerCardItem[]> & { total: number }>(
    '/ceping/exam-line-order',
    {
      method: 'GET',
      params,
    },
  );
}

/**
 * 测评常规题答题卡
 * @param params
 * @returns
 */

export async function getExamAnswerCard(params: {
  exam_id?: string;
  type: 'major' | 'linetest' | 'evaluation';
}) {
  return api<API.Response<SubjectType.SubjectOrder[]>>('/ceping/exam-order-list', {
    method: 'GET',
    params,
  });
}

/**
 * 获取测评试卷详情
 * @param params
 * @returns
 */
export async function getEvalutionExamDetail(params: { id?: string }) {
  return api<API.Response<ExamType.ExamDetailData>>('/ceping/exam-show', {
    method: 'GET',
    params,
  });
}

/**
 *  获取测评题目详情
 * @param params
 * @returns
 */
export async function getEvalutionShow(params: { exam_id?: string; subject_id?: string }) {
  return api<API.Response<{ subject: SubjectType.Subject }>>('/ceping/exam-show-new', {
    method: 'GET',
    params,
  });
}

/**
 * 测评答题
 */
export async function answerEvaluation(data: AnswerType.AnswerRequest) {
  return api<API.Response<SubjectType.Data>>(`/ceping/answer`, {
    method: 'POST',
    data,
  });
}

//交卷
export async function submitEvalutionExam(data: { clint?: string; exam_id: string }) {
  return api<API.Response>(`/ceping/exam-finish`, {
    method: 'POST',
    data,
  });
}
